import { client } from '@/lib/api/client'
import { venueClosurePath, venueClosuresPath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { VenueClosureCreateInput, VenueClosureCreatedView, VenueClosureListView } from './closureTypes'

/**
 * `GET .../closures` (#604).
 * 🚨 게이팅 대상이 아니다 — 이용권이 모두 만료돼도 항상 200(무엇이 잠겼는지는 `editable` 로 안다).
 * 🚨 쿼리 파라미터를 보내지 않는다 — 무필터 단일 쿼리를 클라이언트가 필터링한다(설계 §2 자율 결정 A1).
 */
export async function fetchClosures(venueId: string): Promise<VenueClosureListView> {
  try {
    const { data } = await client.get<VenueClosureListView>(venueClosuresPath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `POST .../closures` (#604).
 * 응답은 등록 후 최신 목록(§조회 와 동일한 View) + 이번 등록의 충돌 정보 — 화면이 재조회하지 않는다.
 */
export async function createClosure(
  venueId: string,
  input: VenueClosureCreateInput
): Promise<VenueClosureCreatedView> {
  try {
    const { data } = await client.post<VenueClosureCreatedView>(venueClosuresPath(venueId), input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `DELETE .../closures/{closureId}` (#604).
 * 🚨 소프트 삭제 — 예약 충돌 검사가 없다(시간을 여는 방향이라 충돌할 수 없다).
 */
export async function deleteClosure(venueId: string, closureId: number): Promise<VenueClosureListView> {
  try {
    const { data } = await client.delete<VenueClosureListView>(venueClosurePath(venueId, closureId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
